export enum ConsentMenuEvents {
  ToggleMenu = 'toggle-menu',
}
